import get from 'lodash.get'
export function get_property(value,attributes='',defaultValue=''){ 
  return get(value,attributes,defaultValue) 
}